import React, { memo, useMemo } from "react";
import { getCustomColor, prepareBetNum } from "../../constants/rollet";
import { env } from "../../env";

const CircleGrid = ({ numbers, onBetting, variant = "default" }) => {
    const preparedNumbers = useMemo(() => {
        return prepareBetNum(numbers || []);
    }, [numbers]);

    const handleBetting = (num) => {
        if (typeof onBetting === "function") {
            onBetting(num);
        }
    };

    const isMobile = variant === "mobile";

    return (
        <div
            className={`circle-grid border-for-${env.PLATFORM_FOR} ${
                isMobile ? "circle-grid--mobile" : ""
            }`}
        >
            {preparedNumbers.map((num, index) => (
                <div
                    key={num?.code || index}
                    className={`circle-cell border-for-${env.PLATFORM_FOR} ${
                        isMobile ? "circle-cell--mobile" : ""
                    }`}
                >
                    <button
                        type="button"
                        onClick={() => handleBetting(num)}
                        className={`circle-btn ${getCustomColor(num?.code)} ${
                            isMobile ? "circle-btn--mobile" : ""
                        }`}
                    >
                        <div className="d-flex justify-content-center">
                            <div className="justify-items-center text-center">
                                <div className="num-cir-roul">{num?.code}</div>
                                <div className="rebate-rate-number">{num?.value}</div>
                            </div>
                        </div>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default memo(CircleGrid);